module.exports = __webpack_public_path__ + "static/JetBrainsMono-Regular-d4ff51ff52d30f839d5be70c33bf872e.woff";